import { useNode } from '@craftjs/core';
import { upperFirst } from 'lodash';
import {
	AutocompleteControl,
	TextControl,
	ToggleButtonGroupControl
} from 'pages/PageEditor/settingsComponents';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import { TypographyVariantsOptions } from '../constants';
import { directionOptions } from './editorDividerSettingsConstants';

const EditorDividerSettings = () => {
	const {
		children,
		typography,
		vertical,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [onChildrenChange, onTypographyChange, onVerticalChange] = useMemo(
		() =>
			['children', 'typography', 'vertical'].map((attr) =>
				generateOnChange(setProp, attr)
			),
		[setProp]
	);

	return (
		<div>
			<TextControl
				value={children}
				label={intl.tr('screenEditor.settings.text')}
				setValue={onChildrenChange}
			/>

			<AutocompleteControl
				label={intl.tr('screenEditor.settings.style')}
				setValue={onTypographyChange}
				value={typography}
				options={TypographyVariantsOptions}
				getOptionLabel={(o) => upperFirst(o as string)}
			/>

			<ToggleButtonGroupControl
				data-testid="horizontal-alignment"
				label={intl.tr('screenEditor.settings.divider.direction')}
				options={directionOptions}
				value={vertical}
				setValue={onVerticalChange}
			/>
		</div>
	);
};

export { EditorDividerSettings };
